<template>
  <v-dialog
    :value="value"
    transition="dialog-top-transition" 
    max-width="30vw"
    @click:outside="close"
    @keydown.esc="close"
  >
    <v-card>
      <v-card-title class="text-h5">
        Точно хотите удалить дашборд?
      </v-card-title>

      <v-card-text>
        Это действие БЕЗВОЗВРАТНО удалит текущий дашборд!!!
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>

        <v-btn
          color="warning"
          text
          @click="close"
        >
          Отмена
        </v-btn>

        <v-btn
          color="red"
          text
          @click="removeDashboard"
        >
          Точно удалить!
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>


<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'DeleteDashboard',
  components: {
  },
  props: {
    value: Boolean,
  },
  data() {
    return {
    }
  },

  computed: {
    ...mapGetters({

    }),

  },

  watch: {
  },

  methods: {
    ...mapActions({
      deleteDashboard: 'dashboard/deleteDashboard',
    }),
    
    close() {
      this.$emit('input', false);
    },

    removeDashboard() {
      this.deleteDashboard();
      this.close();
    },
  },

  mounted() {

  }

}
</script>


<style scoped lang="scss">

</style>